import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskResourcePlanner';

const taskResourcePlannerService = {
  getTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task`,
      data,
    });
  },

  getResources: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/resources`,
    });
  },

  updateTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  searchTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },
};
export default taskResourcePlannerService;
